var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"72ccf1fff02a4b9f5c8271e21c3b1c11f65b032c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["keune@ask-phill"]={id:"72ccf1fff02a4b9f5c8271e21c3b1c11f65b032c"};
      